import { IonToast } from "@ionic/react";
import React, { useState } from "react";

export interface ToastMessageProps {
  showToast: boolean;
  ToastMessage: string;
  severity: string;
  onDidDismiss: Function;
}

export const ToastMessage: React.FC<ToastMessageProps> = ({
  showToast,
  ToastMessage,
  severity,
  onDidDismiss,
}) => {
  return (
    <IonToast
      isOpen={showToast}
      color={severity}
      onDidDismiss={() => onDidDismiss()}
      position="top"
      message={ToastMessage}
      duration={2000}
      cssClass="toast_style"
    />
  );
};
